module.exports = {"title":"Week 6: Presenting","body":"<p>We proceed with our task of automation and classification of the files given.  Additionally, we will present to the class with an update on our process in this project.  Lastly, we will begin the GUI task.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./process/week-6/index.md
// module id = 497
// module chunks = 0